import { useEffect, useState, useCallback } from 'react';
import {
  Breadcrumb,
  Button,
  Col,
  Form,
  Input,
  InputNumber,
  Checkbox,
  Radio,
  Row,
  Select,
  Tooltip,
  Upload,
  message,
  Modal,
} from 'antd';
import {
  fetchDieProfileById,
  updateDieProfile,
  deleteDieImage,
  deleteDieDetailDiagramImage,
  deleteCustomerApprovedDiagramImage,
  deleteAutoCadDrawingDiagramImage,
  deleteDieManuFacturingDiagramImage,
  fetchDieProfilenumber,
  deleteSopDetailDiagramImage,
  updateDieFile,
  deleteDrawingDimensionById
} from './../../slices/die-profile';
import {
  fetchDieSubCategoryListDropdown,
  resetCurrentSubCategoryPage,
  resetDieSubCategoryList,
} from '../../slices/die-subcategory';
import AutoOpenSelect from '../SelectComponent/AutoOpenSelect';
import {
  fetchDieGroupDropdown,
  resetCurrentGroupPage,
  resetDieGroupList,
} from './../../slices/die-group';
import {
  fetchDieCategoryListDropdown,
  resetCurrentCategoryPage,
  resetDieCategoryList,
} from '../../slices/die-category';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { ReactComponent as Back } from '../../Images/Back.svg';
import { debounce } from 'lodash';
import { PlusOutlined, EyeOutlined, MinusCircleOutlined } from '@ant-design/icons';
import { createNumberValidationRule } from '../../utils/CreateNumberValidationRule';
import { createActivityLog } from '../../slices/activity-log';
const { Option } = Select;

export default function EditDieProfile() {
  const { id } = useParams();
  const [form] = Form.useForm();
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const [btnLoading, setBtnLoading] = useState(false);
  const [profileExist, setProfileExist] = useState('');
  const [viewData, setViewData] = useState(null);
  const [isEditing, setIsEditing] = useState(true);
  const [fileList, setFileList] = useState([]);
  const [uploadDiaDiagramError, setUploadDiaDiagramError] = useState('');
  const [detailFileList, setDetailFileList] = useState([]);
  const [uploadDieDetailsDiagramError, setUploadDieDetailsDiagramError] =
    useState('');
  const [
    uploadCustApprovedDieDiageamError,
    setUploadCustApprovedDieDiageamError,
  ] = useState('');
  const [uploadAutocadDrawingError, setUploadAutocadDrawingError] =
    useState('');
  const [uploadDieManufacturingError, setuploadDieManufacturingError] =
    useState('');
  const [sopFileList, setSopFileList] = useState([]);
  const [uploadSOPDiagramError, setUploadSOPDiagramError] = useState('');
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedSubCategory, setSelectedSubCategory] = useState(null);
  const ipAddress = useSelector(state => state.ip.ipAddress);

  const [
    customerApprovedDieDiagramFileList,
    setCustomerApprovedDieDiagramFileList,
  ] = useState([]);
  const [autoCadFileList, setAutoCadFileList] = useState([]);
  const [manufactureFileList, setManufactureFileList] = useState([]);
  const [searchGroup, setSearchGroup] = useState('');
  const [searchCategory, setSearchCategory] = useState('');
  const [searchSubCategory, setSearchSubCategory] = useState('');
  const [selectedDieType, setSelectedDieType] = useState();
  const {
    list: dieGroupList,
    loading: groupLoading,
    currentpage: dieGroupCurrentPage,
    hasMore: dieGroupHasMore,
  } = useSelector(state => state.dieGroup);
  const {
    list: dieCategoryList,
    loading: categoryLoading,
    currentpage: categoryCurrentPage,
    hasMore: dieCategoryHasMore,
  } = useSelector(state => state.dieCategory);
  const {
    list: dieSubCategoryList,
    loading: subCategoryLoading,
    currentPage: subCategoryCurrentPage,
    hasMore: dieSubCategoryHasMore,
  } = useSelector(state => state.dieSubCategory);

  const handleFileChange = info => {
    const newFileList = info.fileList.slice(-1); // Limit to one file
    const fileList = info.fileList[0];
    if (fileList) {
      if (fileList.size / 1024 / 1024 > 2) {
        setUploadDiaDiagramError('File size must be smaller than 2MB!');
        setFileList(newFileList); // Clear the file list if invalid
      } else {
        setUploadDiaDiagramError(''); // Clear error if valid
        setFileList(newFileList);
        form.validateFields(['die_diagram']);
        handleCurrentUploadFile(fileList.originFileObj, 'die_diagram');
      }
    } else {
      setUploadDiaDiagramError(''); // Reset error if no file
      setFileList([]);
    }
  };

  const handleDetailFileChange = info => {
    const newFileList = info.fileList.slice(-1); // Limit to one file
    const fileList = info.fileList[0];
    if (fileList) {
      if (fileList.size / 1024 / 1024 > 2) {
        setUploadDieDetailsDiagramError('File size must be smaller than 2MB!');
        setDetailFileList(newFileList); // Clear the file list if invalid
      } else {
        setUploadDieDetailsDiagramError(''); // Clear error if valid
        setDetailFileList(newFileList);
        handleCurrentUploadFile(fileList.originFileObj, 'die_detail_diagram');
      }
    } else {
      setUploadDieDetailsDiagramError(''); // Reset error if no file
      setDetailFileList([]);
    }
  };

  const handleSopFileChange = info => {
    const newFileList = info.fileList.slice(-1); // Limit to one file
    const fileList = info.fileList[0];
    if (fileList) {
      if (fileList.size / 1024 / 1024 > 2) {
        setUploadSOPDiagramError('File size must be smaller than 2MB!');
        setSopFileList(newFileList); // Clear the file list if invalid
      } else {
        setUploadSOPDiagramError(''); // Clear error if valid
        setSopFileList(newFileList);
        handleCurrentUploadFile(fileList.originFileObj, 'die_sop');
      }
    } else {
      setUploadSOPDiagramError(''); // Reset error if no file
      setSopFileList([]);
    }
  };

  const handleRemoveDieDiagramImage = async file => {
    try {
      if (file.url) {
        const imageUrl = file.name || file.url; // Extract image URL from the file
        const fileId = id; // Extract file ID

        if (!imageUrl || !fileId) {
          throw new Error('Missing file ID or Image URL');
        }
        const response = await dispatch(
          deleteDieImage({ id: fileId, ImageUrl: imageUrl }),
        ).unwrap();
        if (response.message) {
          message.success(response.message);
        } else {
          message.success('Image deleted successfully');
        }
        setFileList([]);
      }
      setFileList([]);
    } catch (error) {
      console.error('Error deleting file:', error);
      message.error(error.message || 'Failed to delete the image');
    }
  };
  const handleRemoveDieDetailDiagramImage = async file => {
    try {
      if (file.url) {
        const imageUrl = file.name || file.url; // Extract image URL from the file
        const fileId = id; // Extract file ID

        if (!imageUrl || !fileId) {
          throw new Error('Missing file ID or Image URL');
        }
        const response = await dispatch(
          deleteDieDetailDiagramImage({ id: fileId, ImageUrl: imageUrl }),
        ).unwrap();

        if (response.message) {
          message.success(response.message);
        } else {
          message.success('Image deleted successfully');
        }
        setDetailFileList([]);
      }
      setDetailFileList([]);
    } catch (error) {
      console.error('Error deleting file:', error);
      message.error(error.message || 'Failed to delete the image');
    }
  };
  const handleRemoveSopDetailDiagramImage = async file => {
    try {
      if (file.url) {
        const imageUrl = file.name || file.url; // Extract image URL from the file
        const fileId = id; // Extract file ID

        if (!imageUrl || !fileId) {
          throw new Error('Missing file ID or Image URL');
        }
        const response = await dispatch(
          deleteSopDetailDiagramImage({ id: fileId, ImageUrl: imageUrl }),
        ).unwrap();

        if (response.message) {
          message.success(response.message);
        } else {
          message.success('Image deleted successfully');
        }
        setSopFileList([]);
      }
      setSopFileList([]);
    } catch (error) {
      console.error('Error deleting file:', error);
      message.error(error.message || 'Failed to delete the image');
    }
  };

  const handleRemoveCustomerApprovedDiagramImage = async file => {
    try {
      if (file.url) {
        const imageUrl = file.name || file.url; // Extract image URL from the file
        const fileId = id; // Extract file ID

        if (!imageUrl || !fileId) {
          throw new Error('Missing file ID or Image URL');
        }
        const response = await dispatch(
          deleteCustomerApprovedDiagramImage({ id: fileId, ImageUrl: imageUrl }),
        ).unwrap();

        if (response.message) {
          message.success(response.message);
        } else {
          message.success('Image deleted successfully');
        }
        setCustomerApprovedDieDiagramFileList([]);
      }
      setCustomerApprovedDieDiagramFileList([]);
    } catch (error) {
      console.error('Error deleting file:', error);
      message.error(error.message || 'Failed to delete the image');
    }
  };
  const handleRemoveAutoCadDiagramImage = async file => {
    try {
      if (file.url) {
        const imageUrl = file.name || file.url; // Extract image URL from the file
        const fileId = id; // Extract file ID

        if (!imageUrl || !fileId) {
          throw new Error('Missing file ID or Image URL');
        }
        const response = await dispatch(
          deleteAutoCadDrawingDiagramImage({ id: fileId, ImageUrl: imageUrl }),
        ).unwrap();

        if (response.message) {
          message.success(response.message);
        } else {
          message.success('Image deleted successfully');
        }
        setAutoCadFileList([]);
      }
      setAutoCadFileList([]);
    } catch (error) {
      console.error('Error deleting file:', error);
      message.error(error.message || 'Failed to delete the image');
    }
  };
  const handleRemoveDiemanufacturingDiagramImage = async file => {
    try {
      if (file.url) {
        const imageUrl = file.name || file.url; // Extract image URL from the file
        const fileId = id; // Extract file ID

        if (!imageUrl || !fileId) {
          throw new Error('Missing file ID or Image URL');
        }
        const response = await dispatch(
          deleteDieManuFacturingDiagramImage({ id: fileId, ImageUrl: imageUrl }),
        ).unwrap();

        if (response.message) {
          message.success(response.message);
        } else {
          message.success('Image deleted successfully');
        }
        setManufactureFileList([]);
      }
    } catch (error) {
      console.error('Error deleting file:', error);
      message.error(error.message || 'Failed to delete the image');
    }
  };

  const getFileType = fileName => {
    const extension = fileName.split('.').pop().toLowerCase(); // Get the file extension
    switch (extension) {
      case 'pdf':
        return 'application/pdf';
      case 'jpeg':
      case 'jpg':
        return 'image/jpeg';
      case 'png':
        return 'image/png';
      case 'dwg':
        return 'dwg';
      default:
        return false; // Fallback for unknown types
    }
  };

  useEffect(() => {
    const fetchDieProfile = async () => {
      try {
        dispatch(fetchDieProfileById(id))
          .unwrap()
          .then(response => {
            if (response.success) {
              const dieProfile = response.data;
              setViewData(prev => ({ ...prev, ...dieProfile }));
              const selectedPressIds = Array.isArray(
                dieProfile.eligible_for_press,
              )
                ? dieProfile.eligible_for_press.map(press => press.id)
                : [];
              setSelectedDieType(dieProfile.die_type);

              form.setFieldsValue({
                die_number: dieProfile.die_number,
                customer_reference_number: dieProfile.customer_reference_number,
                description: dieProfile?.description || '',
                backer_number: dieProfile.backer_number,
                die_type: dieProfile.die_type,
                dimension1: dieProfile.dimension1,
                dimension2: dieProfile.dimension2,
                dimension3: dieProfile.dimension3,
                dimension4: dieProfile.dimension4,
                min_wt_kg_p_mt: dieProfile.min_wt_kg_p_mt,
                wt_kg_p_mt: dieProfile.wt_kg_p_mt,
                max_wt_kg_p_mt: dieProfile.max_wt_kg_p_mt,
                //cutting_dimensions: dieProfile?.cutting_dimensions,
                die_group: dieProfile.die_group?.id,
                die_category: dieProfile.die_category?.id,
                die_sub_category: dieProfile.die_sub_category?.id,
                eligible_for_press: selectedPressIds,
                die_option: dieProfile.die_option,
                diameter: dieProfile.diameter,
                thickness: dieProfile.thickness,
                // total_running_qty: dieProfile.total_running_qty,
                // total_running_ton: dieProfile.total_running_ton,
                remarks: dieProfile.remarks,
                balloon_drawing_dimensions:
                  dieProfile?.balloon_drawing_dimensions?.length > 0
                    ? dieProfile.balloon_drawing_dimensions.map(detail => ({
                      id: detail.id || null,
                      balloon_no: detail?.balloon_no,
                      dim_type: detail?.dim_type,
                      nominal_value: detail?.nominal_value,
                      tolerance_plus: detail?.tolerance_plus,
                      tolerance_minus: detail?.tolerance_minus,
                      min_value: detail?.min_value,
                      max_value: detail?.max_value,
                      description: detail?.description,
                      is_inspection: Boolean(detail?.is_inspection),
                      is_critical: Boolean(detail?.is_critical),
                      pos_x: detail?.pos_x,
                      pos_y: detail?.pos_y
                    }))
                    : [
                      {
                        balloon_no: null,
                        dim_type: "",
                        nominal_value: null,
                        tolerance_plus: null,
                        tolerance_minus: null,
                        min_value: null,
                        max_value: null,
                        description: "",
                        is_inspection: false,
                        is_critical: false,
                        pos_x: null,
                        pos_y: null
                      },
                    ],
              });
              setSelectedGroup(dieProfile.die_group?.id);
              setSelectedCategory(dieProfile.die_category?.id);
              setSelectedSubCategory(dieProfile.die_sub_category?.id);
              setFileList(
                dieProfile.die_diagram
                  ? [
                    {
                      name: dieProfile.die_diagram,
                      url: `${dieProfile.die_diagram}`,
                      type: getFileType(dieProfile.die_diagram),
                    },
                  ]
                  : [],
              );
              setDetailFileList(
                dieProfile.die_detail_diagram
                  ? [
                    {
                      name: dieProfile.die_detail_diagram,
                      url: `${dieProfile.die_detail_diagram}`,
                      type: getFileType(dieProfile.die_detail_diagram),
                    },
                  ]
                  : [],
              );
              setSopFileList(
                dieProfile.die_sop
                  ? [
                    {
                      name: dieProfile.die_sop,
                      url: `${dieProfile.die_sop}`,
                      type: getFileType(dieProfile.die_sop),
                    },
                  ]
                  : [],
              );
              setCustomerApprovedDieDiagramFileList(
                dieProfile.customer_approved_diagram
                  ? [
                    {
                      name: dieProfile.customer_approved_diagram,
                      url: `${dieProfile.customer_approved_diagram}`,
                      type: getFileType(dieProfile.customer_approved_diagram),
                    },
                  ]
                  : [],
              );
              setAutoCadFileList(
                dieProfile.autocad_drawing
                  ? [
                    {
                      name: dieProfile.autocad_drawing,
                      url: `${dieProfile.autocad_drawing}`,
                      type: getFileType(dieProfile.autocad_drawing),
                    },
                  ]
                  : [],
              );
              setManufactureFileList(
                dieProfile.die_manufacturing
                  ? [
                    {
                      name: dieProfile.die_manufacturing,
                      url: `${dieProfile.die_manufacturing}`,
                      type: getFileType(dieProfile.die_manufacturing),
                    },
                  ]
                  : [],
              );
            }
          })
          .catch(error => {
            console.error('');
          });
      } catch (error) {
        console.error('');
      }
    };

    fetchDieProfile();
  }, [id]);

  // useEffect(() => {
  //   const items = form.getFieldValue("balloon_drawing_dimensions");

  //   if (Array.isArray(items)) {
  //     items.forEach((_, i) => {
  //       form.setFieldValue(
  //         ["balloon_drawing_dimensions", i, "balloon_no"],
  //         i + 1
  //       );
  //     });
  //   }
  // }, [form.getFieldValue("balloon_drawing_dimensions")?.length]);

  const handleCurrentUploadFile = (value, filename) => {
    const profileResponse = id;
    dispatch(
      updateDieFile({
        profileResponse,
        filename,
        value,
      }),
    )
      .unwrap()
      .then(result => {
        if (result.success) {
          setBtnLoading(false);
          message.success(result?.message);
          if (result?.die_diagram) {
            setFileList(
              result.die_diagram
                ? [
                  {
                    name: result.die_diagram,
                    url: `${result.die_diagram}`,
                    type: getFileType(result.die_diagram),
                  },
                ]
                : [],
            );
          }
          if (result?.die_detail_diagram) {
            setDetailFileList(
              result.die_detail_diagram
                ? [
                  {
                    name: result.die_detail_diagram,
                    url: `${result.die_detail_diagram}`,
                    type: getFileType(result.die_detail_diagram),
                  },
                ]
                : [],
            );
          }
          if (result?.die_sop) {
            setSopFileList(
              result.die_sop
                ? [
                  {
                    name: result.die_sop,
                    url: `${result.die_sop}`,
                    type: getFileType(result.die_sop),
                  },
                ]
                : [],
            );
          }
          if (result?.customer_approved_diagram) {
            setCustomerApprovedDieDiagramFileList(
              result.customer_approved_diagram
                ? [
                  {
                    name: result.customer_approved_diagram,
                    url: `${result.customer_approved_diagram}`,
                    type: getFileType(result.customer_approved_diagram),
                  },
                ]
                : [],
            );
          }
          if (result?.autocad_drawing) {
            setAutoCadFileList(
              result.autocad_drawing
                ? [
                  {
                    name: result.autocad_drawing,
                    url: `${result.autocad_drawing}`,
                    type: getFileType(result.autocad_drawing),
                  },
                ]
                : [],
            );
          }
          if (result?.die_manufacturing) {
            setManufactureFileList(
              result.die_manufacturing
                ? [
                  {
                    name: result.die_manufacturing,
                    url: `${result.die_manufacturing}`,
                    type: getFileType(result.die_manufacturing),
                  },
                ]
                : [],
            );
          }
        }
      })
      .catch(error => {
        setBtnLoading(false);
        if (typeof error === 'object' && error !== null) {
          const messages = [];
          for (const key in error) {
            if (Array.isArray(error[key])) {
              messages.push(`${key}: ${error[key].join(', ')}`);
            }
          }

          if (messages.length > 0) {
            message.error(messages.join('; '));
          } else {
            message.error('An unknown error occurred.');
          }
        } else if (typeof error === 'string') {
          message.error(error); // Handle string error
        } else if (error instanceof Error) {
          message.error(error.message); // Handle Error object
        } else {
          message.error('An unknown error occurred.');
        }
      });
  };
  const handleSearchProfileNumber = useCallback(
    debounce(value => {
      if (value) {
        dispatch(fetchDieProfilenumber({ die_number: value }))
          .unwrap()
          .then(response => {
            if (response.results.data.length === 0) {
              setProfileExist('');
            } else if (
              response.results.data[0].die_number === viewData.die_number
            ) {
              setProfileExist('');
            } else {
              setProfileExist('Profile Number Allready Exist');
            }
          })
          .catch(error => {
            console.error('Error fetching profile number:', error);
          });
      }
    }, 300), // 300ms debounce delay
    [dispatch, viewData, profileExist],
  );

  const onScrollDieGroup = async event => {
    const target = event.target;
    if (
      !groupLoading &&
      dieGroupHasMore &&
      target.scrollTop + target.offsetHeight === target.scrollHeight
    ) {
      dispatch(
        fetchDieGroupDropdown({ page: dieGroupCurrentPage, pagesize: 1000 }),
      );
    }
  };
  const onScrollDieCategory = async event => {
    const target = event.target;
    if (
      !categoryLoading &&
      dieCategoryHasMore &&
      target.scrollTop + target.offsetHeight === target.scrollHeight
    ) {
      dispatch(
        fetchDieCategoryListDropdown({ page: categoryCurrentPage, pagesize: 10 }),
      );
    }
  };
  const onScrollDieSubCategory = async event => {
    const target = event.target;
    if (
      !subCategoryLoading &&
      dieSubCategoryHasMore &&
      target.scrollTop + target.offsetHeight === target.scrollHeight
    ) {
      dispatch(fetchDieSubCategoryListDropdown, {
        page: subCategoryCurrentPage,
        pagesize: 10,
      });
    }
  };
  useEffect(() => {
    dispatch(resetDieGroupList());
    dispatch(resetDieCategoryList());
    dispatch(resetDieSubCategoryList());
    dispatch(fetchDieGroupDropdown({ page: 1, pagesize: 1000 }));
    dispatch(fetchDieCategoryListDropdown({ page: 1, pagesize: 1000 }));
    dispatch(fetchDieSubCategoryListDropdown({ page: 1, pagesize: 1000 }));
  }, []);

  const handleSearchProfileGroup = value => {
    setSearchGroup(value);
    if (value) {
      dispatch(fetchDieGroupDropdown({ page: 1, pagesize: 1000, search: value }));
      dispatch(resetDieGroupList());
    } else {
      dispatch(resetDieGroupList());
      dispatch(resetCurrentGroupPage());
      dispatch(fetchDieGroupDropdown({ page: 1, pagesize: 1000 }));
    }
  };

  const handleChangeProfileGroup = value => {
    setSearchGroup(value);
    setSelectedGroup(value);
  };
  const getClassName = () => {
    const selected = dieGroupList.find(item => item.id === selectedGroup);
    return selected && selected.deleted === 1
      ? 'inactive-option'
      : 'active-option';
  };
  const handleSearchProfileCategory = value => {
    setSearchCategory(value);
    if (value) {
      setSearchCategory(value);
      dispatch(resetDieCategoryList());
      dispatch(
        fetchDieCategoryListDropdown({ page: 1, pagesize: 1000, search: value }),
      );
    } else {
      dispatch(resetDieCategoryList());
      dispatch(resetCurrentCategoryPage());
      dispatch(fetchDieCategoryListDropdown({ page: 1, pagesize: 1000 }));
    }
  };

  const handleChangeProfileCategory = value => {
    setSearchCategory(value);
    setSelectedCategory(value);
  };
  const getClassNameProfileCategory = () => {
    const selected = dieCategoryList.find(item => item.id === selectedCategory);
    return selected && selected.deleted === 1
      ? 'inactive-option'
      : 'active-option';
  };
  const getClassNameProfileSubCategory = () => {
    const selected = dieSubCategoryList.find(
      item => item.id === selectedSubCategory,
    );
    return selected && selected.deleted === 1
      ? 'inactive-option'
      : 'active-option';
  };
  const handleSearchProfileSubCategory = value => {
    setSearchSubCategory(value);
    if (value) {
      setSearchSubCategory(value);
      dispatch(resetDieSubCategoryList());
      dispatch(
        fetchDieSubCategoryListDropdown({
          page: 1,
          pagesize: 1000,
          search: value,
        }),
      );
    } else {
      setSearchSubCategory('');
      dispatch(resetDieSubCategoryList());
      dispatch(resetCurrentSubCategoryPage());
      dispatch(fetchDieSubCategoryListDropdown({ page: 1, pagesize: 1000 }));
    }
  };

  const handleChangeProfileSubCategory = value => {
    setSearchSubCategory(value);
    setSelectedSubCategory(value);
  };

  const validateFileList = () => {
    if (fileList.length === 0) {
      return Promise.reject(new Error('Please upload a file.'));
    }
    const fileType = fileList[0]?.type;
    if (
      !['application/pdf', 'image/jpeg', 'image/jpg', 'image/png'].includes(
        fileType,
      )
    ) {
      return Promise.reject(new Error('Only PDF or JPEG files are allowed!'));
    }
    return Promise.resolve();
  };
  const validateDetailFileList = () => {
    if (detailFileList.length === 0) {
      return Promise.resolve();
    }
    const fileType = detailFileList[0]?.type;
    if (fileType !== 'application/pdf') {
      return Promise.reject(new Error('Only PDF files are allowed!'));
    }
    return Promise.resolve();
  };
  const validateSopFileList = () => {
    if (sopFileList.length === 0) {
      return Promise.resolve();
    }
    const fileType = sopFileList[0]?.type;
    if (fileType !== 'application/pdf') {
      return Promise.reject(new Error('Only PDF files are allowed!'));
    }
    return Promise.resolve();
  };

  /* Start Handle Customer Approved Die Diagram File Validation */
  const handleCustomerApprovedDieDiagramFileChange = info => {
    const newFileList = info.fileList.slice(-1); // Limit to one file
    const fileList = info.fileList[0];
    if (fileList) {
      if (fileList.size / 1024 / 1024 > 2) {
        setUploadCustApprovedDieDiageamError(
          'File size must be smaller than 2MB!',
        );
        setCustomerApprovedDieDiagramFileList(newFileList); // Clear the file list if invalid
      } else {
        setUploadCustApprovedDieDiageamError(''); // Clear error if valid
        setCustomerApprovedDieDiagramFileList(newFileList);
        handleCurrentUploadFile(
          fileList.originFileObj,
          'customer_approved_diagram',
        );
      }
    } else {
      setUploadCustApprovedDieDiageamError(''); // Reset error if no file
      setCustomerApprovedDieDiagramFileList([]);
    }
  };

  const validateCustomerApprovedFileList = () => {
    if (customerApprovedDieDiagramFileList.length === 0) {
      return Promise.resolve();
    }
    const fileType = customerApprovedDieDiagramFileList[0]?.type;
    if (
      !['application/pdf', 'image/jpeg', 'image/jpg', 'image/png'].includes(
        fileType,
      )
    ) {
      return Promise.reject(new Error('Only PDF or JPEG files are allowed!'));
    }
    return Promise.resolve();
  };

  /* Start AutoCad Drawing File Validation */
  const handleAutoCadFileChange = info => {
    const newFileList = info.fileList.slice(-1); // Limit to one file
    const fileList = info.fileList[0];
    if (fileList) {
      if (fileList.size / 1024 / 1024 > 2) {
        setUploadAutocadDrawingError('File size must be smaller than 2MB!');
        setAutoCadFileList(newFileList); // Clear the file list if invalid
      } else {
        setUploadAutocadDrawingError(''); // Clear error if valid
        setAutoCadFileList(newFileList);
        handleCurrentUploadFile(fileList.originFileObj, 'autocad_drawing');
      }
    } else {
      setUploadAutocadDrawingError(''); // Reset error if no file
      setAutoCadFileList([]);
    }
  };

  const validateAutoCadFileList = () => {
    if (autoCadFileList.length === 0) {
      return Promise.resolve();
    }
    const fileExtension = autoCadFileList[0]?.name
      .split('.')
      .pop()
      ?.toLowerCase();
    if (fileExtension !== 'dwg') {
      return Promise.reject(new Error('Only DWG files are allowed!'));
    }
    return Promise.resolve();
  };

  /* Start Die Manufacturing File Validation */
  const validateDieManufacturingFileList = () => {
    if (manufactureFileList.length === 0) {
      return Promise.resolve();
    }
    const fileExtension = manufactureFileList[0]?.name
      .split('.')
      .pop()
      ?.toLowerCase();
    if (fileExtension !== 'dwg') {
      return Promise.reject(new Error('Only DWG files are allowed!'));
    }
    return Promise.resolve();
  };
  const handleDieManufactureFileChange = info => {
    const newFileList = info.fileList.slice(-1); // Limit to one file
    const fileList = info.fileList[0];
    if (fileList) {
      if (fileList.size / 1024 / 1024 > 2) {
        setuploadDieManufacturingError('File size must be smaller than 2MB!');
        setManufactureFileList(newFileList); // Clear the file list if invalid
      } else {
        setuploadDieManufacturingError(''); // Clear error if valid
        setManufactureFileList(newFileList);
        handleCurrentUploadFile(fileList.originFileObj, 'die_manufacturing');
      }
    } else {
      setuploadDieManufacturingError(''); // Reset error if no file
      setManufactureFileList([]);
    }
  };
  const handleDieTypeChange = e => {
    const value = e.target.value;
    setSelectedDieType(value);
    form.setFieldsValue({
      die_option: undefined, // Reset dependent fields
      backer_number: undefined,
      diameter: undefined,
      thickness: undefined,
    });
  };

  const handleFinish = values => {
    setBtnLoading(true);
    dispatch(
      updateDieProfile({
        id: id,
        values,
      }),
    )
      .unwrap()
      .then(result => {
        if (result.success) {
          setBtnLoading(false);
          navigate(-1);
          message.success('Profile Updated Successfully!');
          dispatch(
            createActivityLog({

              action: 'Update',
              module_name: 'Add New Profile',
              ip_address: ipAddress,
              discription: 'profile created successfully',
            },
            ),
          );
        }
      })
      .catch(error => {
        setBtnLoading(false);
        let displayMessage = '';
        if (typeof error === 'object') {
          displayMessage = Object.entries(error)
            .map(([key, value]) => `${key}: ${value.join(', ')}`)
            .join('\n');
          message.error(displayMessage);
        } else {
          message.error(`Error: ${error || 'Failed to delete the profile.'}`);
        }
      });
  };

  const onFinishFailed = errorInfo => { };
  return (
    <>
      <div className="sticyaction">
        <Row
          className="pagenamerow mb-0"
          justify="space-between"
          align="middle"
        >
          <Col>
            <h2 style={{ margin: 0 }}>Edit Section</h2>
            <div className="bredcrumbwrp">
              <Link onClick={() => navigate(-1)} className="back">
                <Back /> BACK
              </Link>
              <Breadcrumb
                items={[
                  { title: <Link to="/die-profilelist">Section</Link> },
                  { title: 'Edit Section' },
                ]}
              />
            </div>
          </Col>
        </Row>
      </div>
      <div
        className="formwrapper px-4"
        style={{ position: 'sticky', top: 0, zIndex: 1000, background: '#fff' }}
      >
        <Form
          layout="vertical"
          form={form}
          onFinish={handleFinish}
          onFinishFailed={onFinishFailed}
          onValuesChange={(changed, allValues) => {
            const items = allValues.balloon_drawing_dimensions || [];
            items.forEach((_, index) => {
              form.setFieldValue(
                ["balloon_drawing_dimensions", index, "balloon_no"],
                index + 1
              );
            });
          }}
          autoComplete="off"
        >
          <div className="formsection">
            <Row gutter={16}>
              <Col xs={24} sm={12} xl={6} xxl={4}>
                <Form.Item
                  name="die_number"
                  label="Section Number"
                  rules={[
                    {
                      required: true,
                      message: 'Please enter valid profile number',
                    },
                  ]}
                >
                  <Input
                    placeholder="Enter Section Number"
                    maxLength={12}
                    onChange={e => {
                      const value = e.target.value;
                      const formattedValue =
                        value.charAt(0).toUpperCase() +
                        value.slice(1).toLowerCase();
                      form.setFieldsValue({ die_number: formattedValue });
                      handleSearchProfileNumber(formattedValue);
                    }}
                    allowClear
                  />
                </Form.Item>
                {profileExist && (
                  <p
                    style={{ color: '#ff4d4f', marginTop: '-25px' }}
                    className="ant-form-item-explain-error"
                  >
                    {profileExist}
                  </p>
                )}
              </Col>
              <Col xs={24} sm={12} xl={6} xxl={4}>
                <Form.Item
                  name="customer_reference_number"
                  label="Customer Reference No"
                >
                  <Input
                    placeholder="Enter Customer Reference Number"
                    maxLength={25}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} xl={6} xxl={5}>
                <Form.Item
                  name="description"
                  label="Description"
                >
                  <Input
                    placeholder="Enter description"
                    maxLength={25}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} xl={24} xxl={11}>
                <Row gutter={16}>
                  <Col xs={12} sm={6}>
                    <Form.Item
                      name="dimension1"
                      label="Dimension 1* (mm)"
                      rules={[
                        {
                          required: true,
                          message: 'Please enter valid dimension 1',
                        },
                        {
                          validator: (_, value) => {
                            if (!value) {
                              return Promise.resolve();
                            }
                            const regex = /^[0-9]*\.?[0-9]+$/;
                            if (regex.test(value) && parseFloat(value) > 0) {
                              return Promise.resolve();
                            }
                            return Promise.reject(
                              new Error('Dimension1 must be a positive number'),
                            );
                          },
                        },
                        createNumberValidationRule({
                          allowNegative: false,
                          maxBeforeDecimal: 10,
                          maxAfterDecimal: 3,
                          allowDecimal: true,
                          allowZero: true,
                        }),
                      ]}
                    >
                      <Input placeholder="0.0" />
                    </Form.Item>
                  </Col>
                  <Col xs={12} sm={6}>
                    <Form.Item
                      name="dimension2"
                      label="Dimension 2 (mm)"
                      rules={[
                        createNumberValidationRule({
                          allowNegative: false,
                          maxBeforeDecimal: 10,
                          maxAfterDecimal: 3,
                          allowDecimal: true,
                          allowZero: true,
                        }),
                      ]}
                    >
                      <Input placeholder="0.0" />
                    </Form.Item>
                  </Col>
                  <Col xs={12} sm={6}>
                    <Form.Item
                      name="dimension3"
                      label="Dimension 3 (mm)"
                      rules={[
                        createNumberValidationRule({
                          allowNegative: false,
                          maxBeforeDecimal: 10,
                          maxAfterDecimal: 3,
                          allowDecimal: true,
                          allowZero: true,
                        }),
                      ]}
                    >
                      <Input placeholder="0.0" />
                    </Form.Item>
                  </Col>
                  <Col xs={12} sm={6}>
                    <Form.Item
                      name="dimension4"
                      label="Dimension 4 (mm)"
                      rules={[
                        createNumberValidationRule({
                          allowNegative: false,
                          maxBeforeDecimal: 10,
                          maxAfterDecimal: 3,
                          allowDecimal: true,
                          allowZero: true,
                        }),
                      ]}
                    >
                      <Input placeholder="0.0" />
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
              <Col xs={24} sm={12} xl={6} xxl={4}>
                <Form.Item
                  name="wt_kg_p_mt"
                  label="Calculated Kg/Mtr"
                  rules={[
                    {
                      required: true,
                      message: 'Please enter valid weight kg/mtr',
                    },
                    {
                      validator: (_, value) => {
                        if (!value) {
                          return Promise.resolve();
                        }
                        const regex = /^[0-9]*\.?[0-9]+$/;
                        if (regex.test(value) && parseFloat(value) > 0) {
                          return Promise.resolve();
                        }
                        return Promise.reject(
                          new Error('Weight kg/m must be a positive number'),
                        );
                      },
                    },
                    createNumberValidationRule({
                      allowNegative: false,
                      maxBeforeDecimal: 10,
                      maxAfterDecimal: 3,
                      allowDecimal: true,
                      allowZero: true,
                    }),
                  ]}
                >
                  <Input placeholder="Enter Weight kg/mtr"
                    onChange={e => {
                      const value = e.target.value;
                      const num = parseFloat(value);
                      if (!isNaN(num)) {
                        const min = (num * 0.9).toFixed(3);
                        const max = (num * 1.1).toFixed(3);
                        form.setFieldsValue({
                          min_wt_kg_p_mt: min,
                          max_wt_kg_p_mt: max,
                        });
                      } else {
                        form.setFieldsValue({
                          min_wt_kg_p_mt: '',
                          max_wt_kg_p_mt: '',
                        });
                      }
                    }} />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} xl={6} xxl={4}>
                <Form.Item
                  name="min_wt_kg_p_mt"
                  label="Calculated negative kg/mtr"
                >
                  <Input placeholder="0" />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} xl={6} xxl={4}>
                <Form.Item
                  name="max_wt_kg_p_mt"
                  label="Calculated positive kg/mtr"
                >
                  <Input placeholder="0" />
                </Form.Item>
              </Col>
            </Row>
          </div>
          <div className="formrowsection">
            <h5 className="rowsubtitle">Drawing Dimension Details</h5>
            <Form.List name="balloon_drawing_dimensions">
              {(fields, { add, remove }) => (
                <>
                  {fields.map(({ key, name, ...restField }, index) => (
                    <Row
                      className="rowItem mx-0"
                      gutter={[24, 24]}
                      align="middle"
                      key={key}
                      style={{ width: '100%' }}
                    >
                      <Col flex="auto">
                        <Row gutter={16} align="middle">
                          <Col xs={4} sm={2} xl={2}>
                            <Form.Item label="Balloon No." colon={false}>
                              <div style={{ marginTop: 8, fontWeight: 600 }}>
                                {index + 1}
                              </div>

                              <Form.Item
                                name={[name, "balloon_no"]}
                                initialValue={index + 1}
                                style={{ display: "none" }}
                              >
                                <Input type="hidden" />
                              </Form.Item>
                            </Form.Item>
                          </Col>
                          <Col xs={12} sm={8} xl={4}>
                            <Form.Item
                              {...restField}
                              name={[name, 'dim_type']}
                              label="Dimension Type"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please enter dim type',
                                },

                              ]}
                            >
                              <Input
                                placeholder="e.g. Outer Width"

                              />
                            </Form.Item>
                          </Col>
                          <Col xs={12} sm={8} xl={3}>
                            <Form.Item
                              {...restField}
                              name={[name, 'nominal_value']}
                              label="Nominal Value"
                              rules={[
                                { required: true, message: "Please enter nominal value" },
                                {
                                  pattern: /^\d+(\.\d{1,4})?$/,
                                  message: "Enter a valid number (up to 4 decimals)",
                                },
                              ]}
                            >
                              <Input style={{ width: "100%" }} min={0} placeholder="0.0" maxLength={10}
                                value={form.getFieldValue(["balloon_drawing_dimensions", name, "nominal_value"])}
                                onChange={(e) => {
                                  let val = e.target.value;

                                  if (/^\d*\.?\d*$/.test(val)) {
                                    form.setFieldValue(["balloon_drawing_dimensions", name, "nominal_value"], val);
                                  }
                                }} />
                            </Form.Item>
                          </Col>
                          <Col xs={12} sm={8} xl={3}>
                            <Form.Item
                              {...restField}
                              name={[name, 'tolerance_plus']}
                              label="+ Tolerance (mm)"
                              rules={[
                                {
                                  required: false,
                                  message: 'Please enter plus tolerance',
                                },
                                {
                                  pattern: /^\d+(\.\d{1,4})?$/,
                                  message: "Enter a valid number (up to 4 decimals)",
                                },
                              ]}
                            >
                              <Input placeholder="e.g. 1.0" value={form.getFieldValue(["balloon_drawing_dimensions", name, "tolerance_plus"])} />
                            </Form.Item>
                          </Col>
                          <Col xs={12} sm={8} xl={3}>
                            <Form.Item
                              {...restField}
                              name={[name, 'tolerance_minus']}
                              label={`- Tolerance (mm)`}
                              rules={[
                                {
                                  required: false,
                                  message: 'Please enter minus tolerance',
                                },
                                {
                                  pattern: /^\d+(\.\d{1,4})?$/,
                                  message: "Enter a valid number (up to 4 decimals)",
                                },
                              ]}
                            >
                              <Input placeholder="e.g. 1.0" value={form.getFieldValue(["balloon_drawing_dimensions", name, "tolerance_minus"])} />
                            </Form.Item>
                          </Col>
                          <Col xs={12} sm={8} xl={2}>
                            <Form.Item
                              {...restField}
                              name={[name, 'min_value']}
                              label="Min"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please enter min value',
                                },
                                {
                                  pattern: /^\d+(\.\d{1,4})?$/,
                                  message: "Enter a valid number (up to 4 decimals)",
                                },
                              ]}
                            >
                              <Input style={{ width: "100%" }} min={0} placeholder="0.0" value={form.getFieldValue(["balloon_drawing_dimensions", name, "min_value"])} />
                            </Form.Item>
                          </Col>
                          <Col xs={12} sm={8} xl={2}>
                            <Form.Item
                              {...restField}
                              name={[name, 'max_value']}
                              label="Max"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please enter max value',
                                },
                                {
                                  pattern: /^\d+(\.\d{1,4})?$/,
                                  message: "Enter a valid number (up to 4 decimals)",
                                },
                              ]}
                            >
                              <Input style={{ width: "100%" }} min={0} placeholder="0.0" value={form.getFieldValue(["balloon_drawing_dimensions", name, "max_value"])} />
                            </Form.Item>
                          </Col>
                          <Col xs={12} sm={8} xl={4}>
                            <Form.Item
                              {...restField}
                              name={[name, 'description']}
                              label="Description"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please enter description',
                                },

                              ]}
                            >
                              <Input
                                placeholder="e.g. Total outer profile width"

                              />
                            </Form.Item>
                          </Col>
                          <Col xs={12} sm={8} xl={2}>
                            <Form.Item
                              {...restField}
                              name={[name, 'pos_x']}
                              label="X Position"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please enter x positon value',
                                },
                                {
                                  pattern: /^\d+(\.\d{1,3})?$/,
                                  message: "Enter a valid number (up to 2 decimals)",
                                },
                              ]}
                            >
                              <Input style={{ width: "100%" }} min={0} placeholder="0.0" value={form.getFieldValue(["balloon_drawing_dimensions", name, "pos_x"])} />
                            </Form.Item>
                          </Col>
                          <Col xs={12} sm={8} xl={2}>
                            <Form.Item
                              {...restField}
                              name={[name, 'pos_y']}
                              label="Y Postiton"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please enter y positon value',
                                },
                                {
                                  pattern: /^\d+(\.\d{1,3})?$/,
                                  message: "Enter a valid number (up to 2 decimals)",
                                },
                              ]}
                            >
                              <Input style={{ width: "100%" }} min={0} placeholder="0.0" value={form.getFieldValue(["balloon_drawing_dimensions", name, "pos_y"])} />
                            </Form.Item>
                          </Col>
                          <Col xs={12} md={8} xl={4} xxl={4}>

                            <Form.Item
                              {...restField}
                              name={[name, 'is_inspection']}
                              label="Inspection"
                              valuePropName="checked"
                            >
                              <Checkbox>
                                Inspection
                              </Checkbox>
                            </Form.Item>
                          </Col>
                          <Col xs={12} md={8} xl={4} xxl={4}>

                            <Form.Item
                              {...restField}
                              name={[name, 'is_critical']}
                              label="Critical"
                              valuePropName="checked"
                            >
                              <Checkbox>
                                Critical
                              </Checkbox>
                            </Form.Item>
                          </Col>

                          <div className="addwrp">
                            {form.getFieldValue("balloon_drawing_dimensions")[index]?.id !== null && (
                              <Button
                                type="primary"
                                danger
                                icon={<MinusCircleOutlined />}
                                onClick={() => {
                                  const currentDetails = form.getFieldValue("balloon_drawing_dimensions") || [];
                                  const currentItem = currentDetails[index];

                                  if (currentItem?.id) {

                                    Modal.confirm({
                                      title: "Are you sure you want to delete this item?",
                                      content: "This will permanently remove this drawing dimension detail.",
                                      okText: "Yes, Delete",
                                      cancelText: "Cancel",
                                      okButtonProps: { danger: true },
                                      async onOk() {
                                        try {
                                          message.loading({ content: "Deleting...", key: "deleteDetail" });
                                          await dispatch(deleteDrawingDimensionById(currentItem.id)).unwrap();
                                          message.success({ content: "Drawing dimension detail deleted", key: "deleteDetail" });

                                          // Remove from form after successful deletion
                                          remove(name);
                                        } catch (error) {
                                          message.error({ content: "Failed to delete dimension detail", key: "deleteDetail" });
                                        }
                                      },
                                    });
                                  } else {
                                    // 🔹 Just remove locally if not saved
                                    remove(name);
                                  }
                                }}
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                }}
                              />
                            )}
                          </div>
                        </Row>
                      </Col>
                    </Row>
                  ))}
                  <Form.Item>
                    <div className="w-100 flex justify-end">
                      <Button
                        type="primary"
                        onClick={() => {
                          if (fields.length < 500) {
                            add();
                          } else {
                            message.error('You can only add up to 15 records.');
                          }
                        }}
                        icon={<PlusOutlined />}
                      >
                        Add Drawing Dimension Item
                      </Button>
                    </div>
                  </Form.Item>
                </>
              )}
            </Form.List>
          </div>
          <div className="formsection">
            <Row gutter={16}>
              <Col xs={24} sm={12} xl={8} xxl={3}>
                <Form.Item
                  name="die_group"
                  label="Section Group"
                  rules={[
                    {
                      required: true,
                      message: 'Select valid section group',
                    },
                  ]}
                >
                  <AutoOpenSelect
                    placeholder="Select Section Group"
                    value={searchGroup && viewData?.die_group?.id}
                    loading={groupLoading}
                    onPopupScroll={onScrollDieGroup}
                    notFoundContent={groupLoading ? 'Loading...' : 'No options'}
                    showSearch={true}
                    onSearch={handleSearchProfileGroup}
                    onChange={value => {
                      handleChangeProfileGroup(value);
                    }}
                    allowClear={false}
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    dropdownRender={menu => <>{menu}</>}
                    className={getClassName()}
                    all
                  >
                    {dieGroupList.map(el => (
                      <Option
                        key={el.id}
                        value={el.id}
                        disabled={el.deleted === 1}
                      >
                        {el.name}
                      </Option>
                    ))}
                    {groupLoading && <Option>Loading...</Option>}
                  </AutoOpenSelect>
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} xl={8} xxl={3}>
                <Form.Item
                  name="die_category"
                  label="Section Category"
                  rules={[
                    {
                      required: true,
                      message: 'Select valid section category',
                    },
                  ]}
                >
                  <AutoOpenSelect
                    placeholder="Select Section Category"
                    value={searchCategory && viewData?.die_category?.id}
                    loading={categoryLoading}
                    onPopupScroll={onScrollDieCategory}
                    notFoundContent={
                      categoryLoading ? 'Loading...' : 'No options'
                    }
                    showSearch={true}
                    onChange={handleChangeProfileCategory}
                    onSearch={handleSearchProfileCategory}
                    allowClear
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    className={getClassNameProfileCategory()}
                    all
                    dropdownRender={menu => <>{menu}</>}
                  >
                    {dieCategoryList.map(el => (
                      <Option
                        key={el.id}
                        value={el.id}
                        disabled={el.deleted === 1}
                      >
                        {el.name}
                      </Option>
                    ))}
                    {groupLoading && <Option>Loading...</Option>}
                  </AutoOpenSelect>
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} xl={8} xxl={4}>
                <Form.Item name="die_sub_category" label="Section Subcategory">
                  <AutoOpenSelect
                    placeholder="Select Section Subcategory"
                    showSearch={true}
                    value={searchSubCategory && viewData?.die_sub_category?.id}
                    loading={subCategoryLoading}
                    onPopupScroll={onScrollDieSubCategory}
                    notFoundContent={
                      subCategoryLoading ? 'Loading...' : 'No options'
                    }
                    className={getClassNameProfileSubCategory()}
                    all
                    onChange={handleChangeProfileSubCategory}
                    onSearch={handleSearchProfileSubCategory}
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    allowClear
                    dropdownRender={menu => <>{menu}</>}
                  >
                    {dieSubCategoryList.map(el => (
                      <Option
                        key={el.id}
                        value={el.id}
                        disabled={el.deleted === 1}
                      >
                        {el.name}
                      </Option>
                    ))}
                    {subCategoryLoading && <Option>Loading...</Option>}
                  </AutoOpenSelect>
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} xl={8} xxl={6}>
                <Form.Item
                  name="die_type"
                  label="Section Type"
                  rules={[
                    {
                      required: true,
                      message: 'Select a valid profile type',
                    },
                  ]}
                >
                  <Radio.Group
                    onChange={handleDieTypeChange}
                    value={selectedDieType}
                    className="flex "
                  >
                    <Radio value="Hollow">Hollow</Radio>
                    <Radio value="Semi Hollow">Semi Hollow</Radio>
                    <Radio value="Solid">Solid</Radio>
                  </Radio.Group>
                </Form.Item>
              </Col>
              {/* <Col xs={24} sm={12} xl={8} xxl={6}>
                <Form.Item
                  name="total_running_qty"
                  label="Total Running Kilometer"
                  rules={[
                    {
                      pattern: /^\d*\.?\d*$/,
                      message: 'Please enter only digits & decimal.',
                    },
                  ]}
                >
                  <Input placeholder="Enter Kilometre" disabled />
                </Form.Item>
              </Col> */}
              {/* <Col xs={24} sm={12} xl={8} xxl={6}>
                <Form.Item
                  label="Total Running Qty"
                  name="total_running_ton"
                  colon={false}
                  rules={[
                    {
                      pattern: /^\d*\.?\d*$/,
                      message: 'Please enter only digits & decimal.',
                    },
                  ]}
                >
                  <Input placeholder="Enter Metric Ton" disabled />
                </Form.Item>
              </Col> */}
            </Row>
          </div>

          <Form.Item name="remarks" label="Remarks">
            <Input.TextArea
              placeholder="Write a remark, maximum 150 characters"
              maxLength={150}
              onChange={e => {
                const value = e.target.value;
                const formattedValue = value
                  .toLowerCase()
                  .replace(/\b\w/g, char => char.toUpperCase());
                form.setFieldsValue({ remarks: formattedValue });
              }}
            />
          </Form.Item>
          <div className="flex justify-end">
            <Form.Item className="mb-0">
              <Tooltip placement="top" title={'Update Profile'}>
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={btnLoading}
                  disabled={profileExist !== ''}
                  icon={<PlusOutlined />}
                >
                  Update Section
                </Button>
              </Tooltip>
            </Form.Item>
          </div>
        </Form>
        <Form className="pb-5" layout="vertical" autoComplete="off">
          <div className="formsection uploadcardwrap">
            <Row gutter={[16, 16]}>
              <Col xs={24} sm={12} md={8} lg={6}>
                <Form.Item
                  name="die_diagram"
                  label="Section Diagram"
                  style={{ margin: '0' }}
                  rules={[
                    {
                      validator: validateFileList,
                    },
                  ]}
                >
                  <div>
                    <Upload
                      beforeUpload={() => false}
                      listType="picture"
                      accept=".pdf,.jpeg,.jpg,.png"
                      maxCount={1}
                      onRemove={handleRemoveDieDiagramImage}
                      onChange={handleFileChange}
                      fileList={fileList}
                      showUploadList={{
                        showRemoveIcon: isEditing,
                      }}
                    >
                      {fileList.length < 1 && (
                        <div>
                          <PlusOutlined />
                          Upload
                        </div>
                      )}
                    </Upload>
                  </div>
                  {uploadDiaDiagramError && (
                    <div style={{ color: 'red', marginTop: 5 }}>
                      {uploadDiaDiagramError}
                    </div>
                  )}
                  <label className="filenote">
                    {' '}
                    Upload PDF, JPEG, JPG or PNG file
                  </label>
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} md={8} lg={6}>
                <Form.Item
                  name="die_detail_diagram"
                  label="Section Detail Diagram"
                  rules={[
                    {
                      validator: validateDetailFileList,
                    },
                  ]}
                >
                  <div>
                    <Upload
                      beforeUpload={() => false}
                      listType="picture"
                      accept=".pdf"
                      maxCount={1}
                      onRemove={handleRemoveDieDetailDiagramImage}
                      onChange={handleDetailFileChange}
                      fileList={detailFileList}
                    >
                      {detailFileList.length < 1 && (
                        <div>
                          <PlusOutlined />
                          <div>Upload</div>
                        </div>
                      )}
                    </Upload>
                  </div>
                  {uploadDieDetailsDiagramError && (
                    <div style={{ color: 'red', marginTop: 5 }}>
                      {uploadDieDetailsDiagramError}
                    </div>
                  )}
                  <label className="filenote">Upload PDF file</label>
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} md={8} lg={6}>
                <Form.Item
                  name="customer_approved_diagram"
                  label="Customer Approved Section Diagram"
                  rules={[
                    {
                      validator: validateCustomerApprovedFileList,
                    },
                  ]}
                >
                  <div>
                    <Upload
                      beforeUpload={() => false}
                      listType="picture"
                      accept=".pdf,.jpeg,.jpg,.png"
                      maxCount={1}
                      onRemove={handleRemoveCustomerApprovedDiagramImage}
                      onChange={handleCustomerApprovedDieDiagramFileChange}
                      fileList={customerApprovedDieDiagramFileList}
                    >
                      {customerApprovedDieDiagramFileList.length < 1 && (
                        <div>
                          <PlusOutlined />
                          <div>Upload</div>
                        </div>
                      )}
                    </Upload>
                  </div>
                  {uploadCustApprovedDieDiageamError && (
                    <div style={{ color: 'red', marginTop: 5 }}>
                      {uploadCustApprovedDieDiageamError}
                    </div>
                  )}
                  <label className="filenote">
                    {' '}
                    Upload PDF, JPEG, JPG or PNG file
                  </label>
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} md={8} lg={6}>
                <Form.Item
                  name="autocad_drawing"
                  label="Autocad Drawing"
                  rules={[
                    {
                      validator: validateAutoCadFileList,
                    },
                  ]}
                >
                  <div>
                    <Upload
                      beforeUpload={() => false}
                      listType="picture"
                      accept=".dwg"
                      maxCount={1}
                      onRemove={handleRemoveAutoCadDiagramImage}
                      onChange={handleAutoCadFileChange}
                      fileList={autoCadFileList}
                    >
                      {autoCadFileList.length < 1 && (
                        <div>
                          <PlusOutlined />
                          <div>Upload</div>
                        </div>
                      )}
                    </Upload>
                  </div>
                  {uploadAutocadDrawingError && (
                    <div style={{ color: 'red', marginTop: 5 }}>
                      {uploadAutocadDrawingError}
                    </div>
                  )}
                  <label className="filenote">Upload DWG file</label>
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} md={8} lg={6}>
                <Form.Item
                  name="die_manufacturing"
                  label="Section Manufacturing"
                  rules={[
                    {
                      validator: validateDieManufacturingFileList,
                    },
                  ]}
                >
                  <div>
                    <Upload
                      beforeUpload={() => false}
                      listType="picture"
                      accept=".dwg"
                      maxCount={1}
                      onRemove={handleRemoveDiemanufacturingDiagramImage}
                      onChange={handleDieManufactureFileChange}
                      fileList={manufactureFileList}
                    >
                      {manufactureFileList.length < 1 && (
                        <div>
                          <PlusOutlined />
                          <div>Upload</div>
                        </div>
                      )}
                    </Upload>
                  </div>
                  {uploadDieManufacturingError && (
                    <div style={{ color: 'red', marginTop: 5 }}>
                      {uploadDieManufacturingError}
                    </div>
                  )}
                  <label className="filenote">Upload DWG file</label>
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} md={8} lg={6}>
                <Form.Item
                  name="die_sop"
                  label="SOP"
                  rules={[
                    {
                      validator: validateSopFileList,
                    },
                  ]}
                >
                  <div>
                    <Upload
                      beforeUpload={() => false}
                      listType="picture"
                      accept=".pdf"
                      maxCount={1}
                      onRemove={handleRemoveSopDetailDiagramImage}
                      onChange={handleSopFileChange}
                      fileList={sopFileList}
                    >
                      {sopFileList.length < 1 && (
                        <div>
                          <PlusOutlined />
                          <div>Upload</div>
                        </div>
                      )}
                    </Upload>
                  </div>
                  {uploadSOPDiagramError && (
                    <div style={{ color: 'red', marginTop: 5 }}>
                      {uploadSOPDiagramError}
                    </div>
                  )}
                  <label className="filenote">Upload PDF file</label>
                </Form.Item>
              </Col>
            </Row>
          </div>
        </Form>
      </div>
    </>
  );
}
